(() => {

  'use strict';

  angular
    .module('specsguardApp')
    .factory('sgElementItems', sgElementItems);

  function sgElementItems () {

    return {
      setFullName: function (user) {
        let setFullname = '';

        if (user.userId.nameFirst) {
          setFullname += user.userId.nameFirst[0].toUpperCase() + user.userId.nameFirst.slice(1);
        }

        if (user.userId.nameInfix) {
          setFullname += ' ' + user.userId.nameInfix;
        }

        if (user.userId.nameLast) {
          setFullname += ' ' + user.userId.nameLast[0].toUpperCase() + user.userId.nameLast.slice(1);
        }

        return setFullname.trim();
      }
    };

  }

})();
